// Shared asset paths — keep in sync with any direct references in the codebase.
export const LOGO_SRC = '/assets/images/applauss_18__x2-1758554505305.png';

// Official monochrome brand glyphs (from each service's brand kit), rendered
// via the BrandGlyph component. Used by the event page's platform pills
// (EventDescription.jsx) and the Applauss social links (socialLinks.jsx).
// apple-music.svg is staged in the same folder for when artist links carry an
// Apple Music platform.
export const PLATFORM_GLYPHS = {
  spotify: '/assets/images/platforms/spotify.png',
  youtube: '/assets/images/platforms/youtube.png',
  instagram: '/assets/images/platforms/instagram.png',
  x: '/assets/images/platforms/x.png',
  facebook: '/assets/images/platforms/facebook.png',
  tiktok: '/assets/images/platforms/tiktok.png',
  soundcloud: '/assets/images/platforms/soundcloud.png',
  tidal: '/assets/images/platforms/tidal.png',
};

// `public/assets/images/applauss-logo.png` is a second copy of that logotype with a
// stable name, referenced by absolute URL from the API's password-reset email
// (`apps/api/domains/password/email_sender.py`). Don't rename or delete it: emails
// already in someone's inbox fetch it live, and nothing in CI would catch the 404.
// Refresh both files together when the logotype changes.
